import { Stage } from './styles';

export const DotFlashing: React.FC = () => {
  return (
    <Stage>
      <div className="dot-flashing" />
    </Stage>
  );
};
